import React from 'react';
import { Stack, Text, getTheme } from '@fluentui/react';
import { QuoteContent } from '../../type';

interface QuoteWidgetProps {
    content: QuoteContent;
    setShowImageModal: (show: boolean) => void;
}

const QuoteWidget: React.FC<QuoteWidgetProps> = ({ content, setShowImageModal }) => {
    const theme = getTheme();

    return (
        <Stack
            tokens={{ childrenGap: 12 }}
            styles={{
                root: {
                    padding: '16px',
                    backgroundColor: theme.palette.neutralLighter,
                    borderRadius: '8px',
                    border: `1px solid ${theme.palette.neutralLight}`,
                    height: '240px',
                    justifyContent: 'center'
                }
            }}
            onClick={() => setShowImageModal(true)}
        >
            <Text
                variant="medium"
                styles={{
                    root: {
                        color: theme.palette.neutralPrimary,
                        lineHeight: '1.5',
                        marginBottom: '8px'
                    }
                }}
            >
                &ldquo;{content.quote}&rdquo;
            </Text>
            <Text
                variant="small"
                styles={{
                    root: {
                        fontStyle: 'italic',
                        textAlign: 'right',
                        color: theme.palette.neutralSecondary,
                        fontWeight: 600
                    }
                }}
            >
                — {content.author}
            </Text>
        </Stack>
    );
};

export default QuoteWidget;
